import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Cookies from "js-cookie";
import { Row, Col } from "reactstrap";
import { withTranslation, useTranslation } from "react-i18next";
import { ShowOffFieldContainer } from "./ShowOffField";
import { hasPhotoVoted, userIsLogin } from "./Components/VoteWithoutAuth/VoteWithoutAuth";
import { getAuthorNameOfPhoto } from "./helpers";
import { CardShowOff } from "agronomist-ui-components";
import { PhotoModal } from "./Components";

function chunkifyPhotos(photos, chunks) {
  const initialArray = new Array(chunks).fill(null).map(() => []);
  let watchman = -1;
  return photos.reduce((sum, curr) => {
    watchman += 1;
    if (watchman >= chunks) {
      watchman = 0;
    }
    sum[watchman].push(curr);
    return sum;
  }, initialArray);
}

const ShowOffFieldGallery = ({
  onRemove,
  isEditMode,
  onEdit,
  uploadComponent,
  md,
  chunks,
  voteOnPhoto,
  unvoteOnPhoto,

  onVoteWithoutAuth,
  showLogin,
  setShowLogin,
  selected,
  setSelected,
  photoToLike,
  setPhotoToLike,
  latest,
  setLatest,
  userLoggedIn,
  setSelectedPopupVisible,
  selectedPopupVisible,
}) => {
  const { t } = useTranslation(["widgets"]);
  const chunkedPhotos = chunkifyPhotos(latest, chunks);

  return (
    <>
      <ShowOffFieldContainer>
        <Row>
          {chunkedPhotos.map((latest, k) => (
            <Col key={k} sm={12} md={md}>
              <>
                {k === 0 && uploadComponent}
                {!!latest === true && latest.map((el, index) => (
                  <CardShowOff
                    key={`showOff-card-${el.id}`}
                    author={getAuthorNameOfPhoto(el)}
                    authorLabel={t("widgets:photo.author")}
                    imageUrl={el.image_thumbnail}
                    title={el.title}
                    isLiked={hasPhotoVoted(el, userLoggedIn)}
                    isRewarded={!!el.rewards.length}
                    isRewardedLabel={t("widgets:photo.rewarded")}
                    starsCount={el.votes_count}
                    isHigher={false}
                    onClick={() => {
                      setSelected(el)
                      setSelectedPopupVisible(true)
                    }}
                    onVoteClick={() => {
                      if (!userLoggedIn) {
                        onVoteWithoutAuth(el);
                        return;
                      }

                      if (el.voted) {
                        unvoteOnPhoto(el);
                      } else {
                        voteOnPhoto(el);
                      }

                      let newLatest = [...latest];
                      let index = newLatest.findIndex(item => item.id === el.id);
                      newLatest[index] = {
                        ...newLatest[index],
                        voted: !newLatest[index].voted,
                        votes_count: newLatest[index].voted
                          ? newLatest[index].votes_count - 1
                          : newLatest[index].votes_count + 1,
                      };
                      setLatest(newLatest)
                    }}

                    onVoteWithoutAuth={onVoteWithoutAuth}
                    voteOnPhoto={voteOnPhoto}
                    unvoteOnPhoto={unvoteOnPhoto}
                    showLogin={showLogin}
                    setShowLogin={setShowLogin}
                    selected={selected}
                    setSelected={setSelected}
                    photoToLike={photoToLike}
                    setPhotoToLike={setPhotoToLike}
                    latest={latest}
                    setLatest={setLatest}
                    userLoggedIn={userLoggedIn}
                  />
                ))}
              </>
            </Col>
          ))}
        </Row>
      </ShowOffFieldContainer>
      
      <PhotoModal
        isOpen={!!selected}
        onRequestClose={() => {
          setSelected(null)
        }}
        onVoteWithoutAuth={onVoteWithoutAuth}
        voteOnPhoto={voteOnPhoto}
        unvoteOnPhoto={unvoteOnPhoto}
        showLogin={showLogin}
        setShowLogin={setShowLogin}
        selected={selected}
        setSelected={setSelected}
        photoToLike={photoToLike}
        setPhotoToLike={setPhotoToLike}
        latest={latest}
        setLatest={setLatest}
        userLoggedIn={userLoggedIn}
        selectedPopupVisible={selectedPopupVisible}
        setSelectedPopupVisible={setSelectedPopupVisible}
      />

    </>
  );
};

ShowOffFieldGallery.propTypes = {
  photos: PropTypes.arrayOf(PropTypes.object).isRequired,
  onClick: PropTypes.func.isRequired,
  onVoteClick: PropTypes.func.isRequired,
  uploadComponent: PropTypes.element,
  isEditMode: PropTypes.bool,
  onRemove: PropTypes.func,
  md: PropTypes.number,
  chunks: PropTypes.arrayOf(PropTypes.array),
};
ShowOffFieldGallery.defaultProps = {
  uploadComponent: null,
  isEditMode: false,
  md: 4,
  chunks: 3,
  onRemove: () => { },
};

export default withTranslation(["widgets"])(ShowOffFieldGallery);
